<template>
<div style="margin-top: 30px; padding: 25px;">

  <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
    Sözleşme Alan Ekle/Düzenle
  </button>

  <div class="table-responsive">
    <table class="table align-middle">
      <thead>
      <tr>
        <td>İsim</td>
        <td>Alan ID</td>
        <td>Alan Tipi</td>
        <td>Varsayılan Olarak Gözüksün</td>
        <td>İşlemler</td>
      </tr>
      </thead>

      <tbody>
      <tr v-for="val in contractDefinitionData" v-bind:key="val.id">
        <td>{{val.name}}</td>
        <td>{{val.inputName}}</td>
        <td>{{val.inputType}}</td>
        <td>{{val.isVisible}}</td>
        <td>
          <button type="button" class="btn btn-danger">Sil</button> &nbsp;
          <button type="button" class="btn btn-secondary">Düzenle</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Sözleşme Alan Ekle/Düzenle</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label">Alan ID</label>
            <input type="text" class="form-control" v-model="items.inputName" id="exampleFormControlInput1" placeholder="Alan ID">
          </div>
          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label">Alan Adı</label>
            <input type="text" class="form-control" v-model="items.name" id="exampleFormControlInput1" placeholder="Alan Adı">
          </div>
          <div class="mb-3">
          <label for="exampleFormControlInput1" class="form-label">Alan Tipi</label>
          <select class="form-select" v-model="items.inputType" aria-label="Default select example">
            <option value="NUMBER">Sayısal</option>
            <option value="TEXT">Metin</option>
            <option value="CHECKBOX">Onay</option>
            <option value="DATE">Tarih</option>
          </select>
          </div>
          <div class="form-check">
            <input class="form-check-input" v-model="items.isVisible" type="checkbox" value="" id="flexCheckDefault">
            <label class="form-check-label" for="flexCheckDefault">
              Sözleşmelerde varsayılan olarak gelsin
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Vazgeç</button>
          <button type="button" @click="saveData" data-bs-dismiss="modal" class="btn btn-primary">Kaydet</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
// @ts-nocheck
import apiClient from "@/axios";

export default {
  name: "Users",
  data(){
    return{
      items:{},
      contractDefinitionData:[]
    }
  },
  created() {
    this.getData();
  },
  methods:{
    getData(){
      apiClient.get("contract-definition-fields").then(res =>  {
        this.contractDefinitionData = res.data;
      })
    },
    saveData(){
      apiClient.post('/contract-definition-fields', this.items).then(res => {
        this.getData();
        this.items = {};
        console.log(res.data)
      })
    }
  }
}
</script>

<style scoped>

</style>